/*
  Список докторов и выбор участвующих
*/

import './Doctors.css';
import '../css/Main.css';
import React , { useState, useEffect } from 'react'
import axios_sender from '../modules/axios_sender.js'
import { getWorkerType, IsSelectedWorker, addWorker, deleteWorker } from '../modules/workers'
import unique from '../modules/unique.js'

var ListWorker = [];    // список персонала

function Doctors(props) {


  const [list_worker, SetListWorker] = useState();            // список сотрудников

  useEffect(() => {
    LoadWorkers();
  }, []);

  return (
    <>
    <div className="page-caption">Список сотрудников участвующих в услуге</div>
      <div>
        { list_worker }
      </div>
    </>
  );

  

  // загрузка отрудников из БД
  async function LoadWorkers()
  {
      axios_sender({form: 'get_workers'}, LoadWorkersSuccess);
  } 
  function LoadWorkersSuccess(data)
  {
      ListWorker = [];

      for(var i in data)
      {
          let work_type = getWorkerType(data[i]);
          ListWorker.push( { id: data[i].ID, name: data[i].name, work_type: work_type } );
      }

      // обновим список
      ReplaceListDoctors();
  }

  function ReplaceListDoctors()
  {
      let li = [];
      let cnt_select = 0;
      for(var i in ListWorker)
      {
          let worker = ListWorker[i];
          let name = worker.name;
          let key = unique();

          let cn_worker_type = "col-1 lw_d1 cn_" + worker.work_type;          

          let cn = "row one-worker";
          
          if(IsSelectedWorker(worker.id)) { cn += " selected"; cnt_select ++; }

          li.push(
            <div key={ key } className={ cn } onClick={ (event) => SelectWorker(worker.id, event) }>
                <div className={ cn_worker_type }></div>
                <div className="container d-flex align-items-center col worker_name">{ name }</div>
            </div>
          );     
      }

      SetListWorker(li);
      props.FillWorkersCount(cnt_select);
  }

  function SelectWorker(id, event)
  {
      if(IsSelectedWorker(id)) deleteWorker(id);
      else addWorker(id);
      // обновим список
      ReplaceListDoctors();
  }

}

export default Doctors;
